function formatPath(path) {
    return path.length > 0 ? path : "value";
}
export function expectRecord(value, path = "") {
    if (typeof value !== "object" || value === null || Array.isArray(value)) {
        throw new Error(`${formatPath(path)} must be an object`);
    }
    return value;
}
export function expectString(value, path = "") {
    if (typeof value !== "string" || value.length === 0) {
        throw new Error(`${formatPath(path)} must be a non-empty string`);
    }
    return value;
}
export function expectOptionalString(value, path = "") {
    if (value === null || value === undefined) {
        return null;
    }
    if (typeof value !== "string") {
        throw new Error(`${formatPath(path)} must be a string`);
    }
    const normalized = value.trim();
    return normalized.length > 0 ? normalized : null;
}
export function expectNumber(value, path = "") {
    if (typeof value !== "number" || !Number.isFinite(value)) {
        throw new Error(`${formatPath(path)} must be a finite number`);
    }
    return value;
}
export function expectBoolean(value, path = "") {
    if (typeof value !== "boolean") {
        throw new Error(`${formatPath(path)} must be a boolean`);
    }
    return value;
}
export function expectNullable(value, parser, path = "") {
    if (value === null || value === undefined) {
        return null;
    }
    return parser(value, path);
}
export function expectArray(value, parser, path = "") {
    if (!Array.isArray(value)) {
        throw new Error(`${formatPath(path)} must be an array`);
    }
    return value.map((item, index) => parser(item, `${formatPath(path)}[${index}]`));
}
